let REACT_APP_API_URL;

// Check if running in staging environment
if (process.env.REACT_APP_ENVIRONMENT === 'development') {
    REACT_APP_API_URL = process.env.REACT_APP_DEVELOPMENT_API_URL;
  }

// Check if running in staging environment
if (process.env.REACT_APP_ENVIRONMENT === 'staging') {
  REACT_APP_API_URL = process.env.REACT_APP_STAGING_API_URL;
}

// Check if running in production environment
if (process.env.REACT_APP_ENVIRONMENT === 'production') {
  REACT_APP_API_URL = process.env.REACT_APP_PRODUCTION_API_URL;
}

// Check if running in preview environment
if (process.env.REACT_APP_ENVIRONMENT === 'preview') {
  REACT_APP_API_URL = process.env.REACT_APP_PREVIEW_API_URL;
}

// Check if running in KBC environment
if (process.env.REACT_APP_ENVIRONMENT === 'KBC') {
  REACT_APP_API_URL = process.env.REACT_APP_KBC_API_URL;
}

// Check if running in Vandelanotte environment
if (process.env.REACT_APP_ENVIRONMENT === 'vandelanotte-staging') {
  REACT_APP_API_URL = process.env.REACT_APP_VANDELANOTTE_STAGING_API_URL;
}

// Check if running in Vandelanotte environment
if (process.env.REACT_APP_ENVIRONMENT === 'vandelanotte') {
  REACT_APP_API_URL = process.env.REACT_APP_VANDELANOTTE_API_URL;
}

export default REACT_APP_API_URL;